//遊戲回放：點擊時即時取得回放網址
function getGameReplay(e) {
  var orderid = $(e).closest("[data-orderid]").data("orderid");
  if (!orderid) {
    swal("查無此注單", "", "error");
    return;
  }
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data: { a: "getGameReplay", orderid: orderid },
    dataType: "json",
  })
    .fail(function () {
      swal("出現問題，請稍後再試!", "", "error");
    })
    .done(function (res) {
      if (res.success == 0 && res.data && res.data.url && /^https?:\/\//.test(res.data.url)) {
        window.open(res.data.url, "_blank", "noopener,noreferrer");
      } else {
        swal(res.msg || "連結已失效，請稍後再試", "", "error");
      }
    });
}

//派彩紀錄
function his_lottery(page,animation=1) {
  //暫時解決投注紀錄重複動畫
  if(animation ===1 ){
    $("#loader-bg").fadeIn();
  }

  var _ghall = $("#betplat").val();
  var _page = page ? page : 1;
  var resu1 = "輸";
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data:
      "a=getRecord&t=lottery" +
      "&p=" +
      _page +
      "&ghall=" +
      _ghall +
      "&sd=" +
      startData +
      "&ed=" +
      endData,
    dataType: "json",
  })
    .fail(function (res) {
      console.log("fail");
      $("#loader-bg").fadeOut();
      swal("資料查詢失敗", "", "error");
    })
    .done(function (res) {
      $("#loader-bg").fadeOut();
      if (res.success == 0) {
        var content = "";

        for (i = 0; i < res.data.r.length; i++) {
          content +=
            "<tr>" +
            "<td>" +
            res.data.r[i].WagerDate +
            "</td>" +
            "<td>" +
            res.data.r[i].WagerID +
            "</td>" +
            "<td>" +
            res.data.r[i].HallName +
            " " +
            res.data.r[i].TypeName +
            "</td>" +
            "<td style='text-align:left; padding-left: 10px;' data-orderid='" +
            res.data.r[i].OrderID +
            "'>" +
            res.data.r[i].BetItem +
            "</td>" +
            "<td>" +
            res.data.r[i].Result +
            "</td>" +
            "<td style='text-align: right;'>" +
            res.data.r[i].Amount +
            "</td>" +
            "<td style='text-align: right;'>" +
            res.data.r[i].PayOff +
            "</td>" +
            "<td style='text-align: right; padding-right:10px;'>" +
            res.data.r[i].BetAmount +
            "</td>" +
            "</tr>";
        }

        if (res.data.c) {
          $(".record_total_amount").text(res.data.c[0].CAmount)
          $(".record_payoff").text(res.data.c[0].CPayOff)
        } else {
          $(".record_total_amount").text('0')
          $(".record_payoff").text('0')
        }

        if (res.data.p.TotalCount !== 0) {
          $(".noRecord").hide();
          var _pagination = '<li><a onclick="his_lottery(1)">«</a></li>';
          if (res.data.p.TotalPage < 6) {
            for (var i = 1; i <= res.data.p.TotalPage; i++) {
              if (i == res.data.p.ThisPage) {
                _pagination +=
                  '<li><a class="active" onclick="his_lottery(' +
                  i +
                  ')">' +
                  i +
                  "</a></li>";
              } else {
                _pagination +=
                  '<li><a onclick="his_lottery(' + i + ')">' + i + "</a></li>";
              }
            }
          } else {
            if (res.data.p.ThisPage < 3) {
              for (var i = 1; i <= 3; i++) {
                if (i == res.data.p.ThisPage) {
                  _pagination +=
                    '<li><a class="active" onclick="his_lottery(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                } else {
                  _pagination +=
                    '<li><a onclick="his_lottery(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                }
              }
              _pagination += '<li><a onclick="#">...</a></li>';
              _pagination +=
                '<li><a onclick="his_lottery(' +
                (res.data.p.TotalPage - 1) +
                ')">' +
                (res.data.p.TotalPage - 1) +
                "</a></li>";
              _pagination +=
                '<li><a onclick="his_lottery(' +
                res.data.p.TotalPage +
                ')">' +
                res.data.p.TotalPage +
                "</a></li>";
            } else if (res.data.p.ThisPage > res.data.p.TotalPage - 2) {
              _pagination += '<li><a onclick="his_lottery(1)">1</a></li>';
              _pagination += '<li><a onclick="his_lottery(2)">2</a></li>';
              _pagination += '<li><a onclick="#">...</a></li>';
              for (
                var i = res.data.p.TotalPage - 2;
                i <= res.data.p.TotalPage;
                i++
              ) {
                if (i == res.data.p.ThisPage) {
                  _pagination +=
                    '<li><a class="active" onclick="his_lottery(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                } else {
                  _pagination +=
                    '<li><a onclick="his_lottery(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                }
              }
            } else {
              _pagination += '<li><a onclick="his_lottery(1)">1</a></li>';
              if (res.data.p.ThisPage > 3) {
                _pagination += '<li><a onclick="#">...</a></li>';
              }
              for (
                var i = res.data.p.ThisPage - 1;
                i <= res.data.p.ThisPage + 1;
                i++
              ) {
                if (i == res.data.p.ThisPage) {
                  _pagination +=
                    '<li><a class="active" onclick="his_lottery(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                } else {
                  _pagination +=
                    '<li><a onclick="his_lottery(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                }
              }
              if (res.data.p.ThisPage <= res.data.p.TotalPage - 3) {
                _pagination += '<li><a onclick="#">...</a></li>';
              }
              _pagination +=
                '<li><a onclick="his_lottery(' +
                res.data.p.TotalPage +
                ')">' +
                res.data.p.TotalPage +
                "</a></li>";
            }
          }
          _pagination +=
            '<li><a onclick="his_lottery(' +
            res.data.p.TotalPage +
            ')">»</a></li>';

          $(".pagination").empty().html(_pagination);
          $(".betTable2 tbody").empty().append(content);
        } else {
          console.log("no data");
          $(".betTable2 tbody").empty();
          $(".noRecord").show();
          $(".pagination").empty();
        }

        $(".rnote").on("click", function () {
          var rnote = $(this).data("note");
          swal("備註", html_encode(rnote));
        });
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "/logout";
              });
            }
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
        console.log("no data");
      }
    });
}

//儲值紀錄
function his_deposit(page,animation=1) {
  //暫時解決儲值紀錄重複動畫
  if(animation === 1){
    $("#loader-bg").fadeIn();
  }

  var _page = page ? page : 1;
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data:
      "a=getRecord&t=deposit" +
      "&p=" +
      _page +
      "&sd=" +
      startData +
      "&ed=" +
      endData,
    dataType: "json",
  })
    .fail(function (res) {
      console.log("fail");
      $("#loader-bg").fadeOut();
      swal("資料查詢失敗", "", "error");
    })
    .done(function (res) {
      $("#loader-bg").fadeOut();

      if (res.success == 0) {
        var content = "";

        for (i = 0; i < res.data.r.length; i++) {
          content +=
            "<tr>" +
            "<td>" +
            ((res.data.p.ThisPage - 1) * 20 + (i + 1)) +
            "</td>" +
            "<td>" +
            res.data.r[i].CreateDate +
            "</td>" +
            "<td>" +
            res.data.r[i].TicketID +
            "</td>" +
            "<td>儲值</td>" +
            "<td class='text-right' style='padding-right: 25px;'>" +
            res.data.r[i].Amount +
            "</td>" +
            "<td>" +
            res.data.r[i].TicketStatus +
            "</td>";

          if (res.data.r[i].Reply) {
            content +=
              '<td><span class="btn btn-sm btn-info" style="cursor: help;"><span class="rnote" data-note="' +
              html_encode(res.data.r[i].Reply) +
              '">詳情</span></span></td>';
          } else {
            content += "<td></td>";
          }
          content += "</tr>";
        }

        if (res.data.p.TotalCount !== 0) {
          $(".noRecord").hide();
          var _pagination = '<li><a onclick="his_deposit(1)">«</a></li>';
          if (res.data.p.TotalPage < 6) {
            for (var i = 1; i <= res.data.p.TotalPage; i++) {
              if (i == res.data.p.ThisPage) {
                _pagination +=
                  '<li><a class="active" onclick="his_deposit(' +
                  i +
                  ')">' +
                  i +
                  "</a></li>";
              } else {
                _pagination +=
                  '<li><a onclick="his_deposit(' + i + ')">' + i + "</a></li>";
              }
            }
          } else {
            if (res.data.p.ThisPage < 3) {
              for (var i = 1; i <= 3; i++) {
                if (i == res.data.p.ThisPage) {
                  _pagination +=
                    '<li><a class="active" onclick="his_deposit(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                } else {
                  _pagination +=
                    '<li><a onclick="his_deposit(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                }
              }
              _pagination += '<li><a onclick="#">...</a></li>';
              _pagination +=
                '<li><a onclick="his_deposit(' +
                (res.data.p.TotalPage - 1) +
                ')">' +
                (res.data.p.TotalPage - 1) +
                "</a></li>";
              _pagination +=
                '<li><a onclick="his_deposit(' +
                res.data.p.TotalPage +
                ')">' +
                res.data.p.TotalPage +
                "</a></li>";
            } else if (res.data.p.ThisPage > res.data.p.TotalPage - 2) {
              _pagination += '<li><a onclick="his_deposit(1)">1</a></li>';
              _pagination += '<li><a onclick="his_deposit(2)">2</a></li>';
              _pagination += '<li><a onclick="#">...</a></li>';
              for (
                var i = res.data.p.TotalPage - 2;
                i <= res.data.p.TotalPage;
                i++
              ) {
                if (i == res.data.p.ThisPage) {
                  _pagination +=
                    '<li><a class="active" onclick="his_deposit(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                } else {
                  _pagination +=
                    '<li><a onclick="his_deposit(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                }
              }
            } else {
              _pagination += '<li><a onclick="his_deposit(1)">1</a></li>';
              if (res.data.p.ThisPage > 3) {
                _pagination += '<li><a onclick="#">...</a></li>';
              }
              for (
                var i = res.data.p.ThisPage - 1;
                i <= res.data.p.ThisPage + 1;
                i++
              ) {
                if (i == res.data.p.ThisPage) {
                  _pagination +=
                    '<li><a class="active" onclick="his_deposit(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                } else {
                  _pagination +=
                    '<li><a onclick="his_deposit(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                }
              }
              if (res.data.p.ThisPage <= res.data.p.TotalPage - 3) {
                _pagination += '<li><a onclick="#">...</a></li>';
              }
              _pagination +=
                '<li><a onclick="his_deposit(' +
                res.data.p.TotalPage +
                ')">' +
                res.data.p.TotalPage +
                "</a></li>";
            }
          }
          _pagination +=
            '<li><a onclick="his_deposit(' +
            res.data.p.TotalPage +
            ')">»</a></li>';          $(".pagination").empty().html(_pagination);
          $(".recordTable tbody").empty().html(content);
        } else {
          console.log("no data");
          $("#gtdeposit").show();
        }

        $(".rnote").on("click", function () {
          var rnote = $(this).data("note");
          swal("備註", html_encode(rnote));
        });
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "/logout";
              });
            }
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
        console.log("no data");
        $("#gtdeposit").show();
      }
    });
}

//轉移紀錄
function his_transfer(page) {
  $("#loader-bg").fadeIn();

  var _page = page ? page : 1;
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data:
      "a=getRecord&t=transfer" +
      "&p=" +
      _page +
      "&sd=" +
      startData +
      "&ed=" +
      endData,
    dataType: "json",
  })
    .fail(function (res) {
      console.log("fail");
      $("#loader-bg").fadeOut();
      swal("資料查詢失敗", "", "error");
    })
    .done(function (res) {
      $("#loader-bg").fadeOut();

      if (res.success == 0) {
        var content = "";

        for (i = 0; i < res.data.r.length; i++) {
          content +=
            "<tr>" +
            '<td class="text-center">' +
            (i + 1) +
            "</td>" +
            '<td class="text-center">' +
            res.data.r[i].CreateDate +
            "</td>" +
            "<td>" +
            res.data.r[i].TicketID +
            "</td>" +
            "<td>" +
            res.data.r[i].FromHall +
            "->" +
            res.data.r[i].ToHall +
            "</td>" +
            '<td class="text-right"style="padding-right: 25px;">' +
            res.data.r[i].Amount +
            "</td>" +
            "<td>" +
            res.data.r[i].TicketStatus +
            "</td>" +
            "</tr>";
        }

        if (res.data.p.TotalCount !== 0) {
          $(".noRecord").hide();
          var _pagination = '<li><a onclick="his_transfer(1)">«</a></li>';

          if (res.data.p.TotalPage < 6) {
            for (var i = 1; i <= res.data.p.TotalPage; i++) {
              if (i == res.data.p.ThisPage) {
                _pagination +=
                  '<li><a class="active" onclick="his_transfer(' +
                  i +
                  ')">' +
                  i +
                  "</a></li>";
              } else {
                _pagination +=
                  '<li><a onclick="his_transfer(' + i + ')">' + i + "</a></li>";
              }
            }
          } else {
            if (res.data.p.ThisPage < 3) {
              for (var i = 1; i <= 3; i++) {
                if (i == res.data.p.ThisPage) {
                  _pagination +=
                    '<li><a class="active" onclick="his_transfer(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                } else {
                  _pagination +=
                    '<li><a onclick="his_transfer(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                }
              }
              _pagination += '<li><a onclick="#">...</a></li>';
              _pagination +=
                '<li><a onclick="his_transfer(' +
                (res.data.p.TotalPage - 1) +
                ')">' +
                (res.data.p.TotalPage - 1) +
                "</a></li>";
              _pagination +=
                '<li><a onclick="his_transfer(' +
                res.data.p.TotalPage +
                ')">' +
                res.data.p.TotalPage +
                "</a></li>";
            } else if (res.data.p.ThisPage > res.data.p.TotalPage - 2) {
              _pagination += '<li><a onclick="his_transfer(1)">1</a></li>';
              _pagination += '<li><a onclick="his_transfer(2)">2</a></li>';
              _pagination += '<li><a onclick="#">...</a></li>';
              for (
                var i = res.data.p.TotalPage - 2;
                i <= res.data.p.TotalPage;
                i++
              ) {
                if (i == res.data.p.ThisPage) {
                  _pagination +=
                    '<li><a class="active" onclick="his_transfer(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                } else {
                  _pagination +=
                    '<li><a onclick="his_transfer(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                }
              }
            } else {
              _pagination += '<li><a onclick="his_transfer(1)">1</a></li>';
              if (res.data.p.ThisPage > 3) {
                _pagination += '<li><a onclick="#">...</a></li>';
              }
              for (
                var i = res.data.p.ThisPage - 1;
                i <= res.data.p.ThisPage + 1;
                i++
              ) {
                if (i == res.data.p.ThisPage) {
                  _pagination +=
                    '<li><a class="active" onclick="his_transfer(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                } else {
                  _pagination +=
                    '<li><a onclick="his_transfer(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                }
              }
              if (res.data.p.ThisPage <= res.data.p.TotalPage - 3) {
                _pagination += '<li><a onclick="#">...</a></li>';
              }
              _pagination +=
                '<li><a onclick="his_transfer(' +
                res.data.p.TotalPage +
                ')">' +
                res.data.p.TotalPage +
                "</a></li>";
            }
          }

          _pagination +=
            '<li><a onclick="his_transfer(' +
            res.data.p.TotalPage +
            ')">»</a></li>';
          $(".pagination").empty().html(_pagination);
          $(".recordTable tbody").empty().html(content);
        } else {
          console.log("no data");
        }
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "/logout";
              });
            }
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
        console.log("no data");
      }
    });
}

//託售紀錄
function his_withdrawal(page) {
  $("#loader-bg").fadeIn();

  var _page = page ? page : 1;
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data:
      "a=getRecord&t=withdrawal" +
      "&p=" +
      _page +
      "&sd=" +
      startData +
      "&ed=" +
      endData,
    dataType: "json",
  })
    .fail(function (res) {
      console.log("fail");
      $("#loader-bg").fadeOut();
      swal("資料查詢失敗", "", "error");
    })
    .done(function (res) {
      $("#loader-bg").fadeOut();

      if (res.success == 0) {
        var content = "";

        for (i = 0; i < res.data.r.length; i++) {
          content +=
            "<tr>" +
            '<td class="text-center">' +
            (i + 1) +
            "</td>" +
            '<td class="text-center">' +
            res.data.r[i].CreateDate +
            "</td>" +
            "<td>" +
            res.data.r[i].TicketID +
            "</td>" +
            "<td>託售</td>" +
            '<td class="text-right" style="padding-right: 25px;">' +
            res.data.r[i].Amount +
            "</td>" +
            "<td>" +
            res.data.r[i].TicketStatus +
            "</td>";
          if (res.data.r[i].Reply) {
            content +=
              '<td><span class="btn btn-sm btn-info" style="cursor: help;"><span class="rnote" data-note="' +
              html_encode(res.data.r[i].Reply) +
              '">詳情</span></span></td>';
          } else {
            content += "<td></td>";
          }
          content += "</tr>";
        }

        if (res.data.p.TotalCount !== 0) {
          $(".noRecord").hide();
          var _pagination = '<li><a onclick="his_withdrawal(1)">«</a></li>';

          if (res.data.p.TotalPage < 6) {
            for (var i = 1; i <= res.data.p.TotalPage; i++) {
              if (i == res.data.p.ThisPage) {
                _pagination +=
                  '<li><a class="active" onclick="his_withdrawal(' +
                  i +
                  ')">' +
                  i +
                  "</a></li>";
              } else {
                _pagination +=
                  '<li><a onclick="his_withdrawal(' + i + ')">' + i + "</a></li>";
              }
            }
          } else {
            if (res.data.p.ThisPage < 3) {
              for (var i = 1; i <= 3; i++) {
                if (i == res.data.p.ThisPage) {
                  _pagination +=
                    '<li><a class="active" onclick="his_withdrawal(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                } else {
                  _pagination +=
                    '<li><a onclick="his_withdrawal(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                }
              }
              _pagination += '<li><a onclick="#">...</a></li>';
              _pagination +=
                '<li><a onclick="his_withdrawal(' +
                (res.data.p.TotalPage - 1) +
                ')">' +
                (res.data.p.TotalPage - 1) +
                "</a></li>";
              _pagination +=
                '<li><a onclick="his_withdrawal(' +
                res.data.p.TotalPage +
                ')">' +
                res.data.p.TotalPage +
                "</a></li>";
            } else if (res.data.p.ThisPage > res.data.p.TotalPage - 2) {
              _pagination += '<li><a onclick="his_withdrawal(1)">1</a></li>';
              _pagination += '<li><a onclick="his_withdrawal(2)">2</a></li>';
              _pagination += '<li><a onclick="#">...</a></li>';
              for (
                var i = res.data.p.TotalPage - 2;
                i <= res.data.p.TotalPage;
                i++
              ) {
                if (i == res.data.p.ThisPage) {
                  _pagination +=
                    '<li><a class="active" onclick="his_withdrawal(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                } else {
                  _pagination +=
                    '<li><a onclick="his_withdrawal(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                }
              }
            } else {
              _pagination += '<li><a onclick="his_withdrawal(1)">1</a></li>';
              if (res.data.p.ThisPage > 3) {
                _pagination += '<li><a onclick="#">...</a></li>';
              }
              for (
                var i = res.data.p.ThisPage - 1;
                i <= res.data.p.ThisPage + 1;
                i++
              ) {
                if (i == res.data.p.ThisPage) {
                  _pagination +=
                    '<li><a class="active" onclick="his_withdrawal(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                } else {
                  _pagination +=
                    '<li><a onclick="his_withdrawal(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                }
              }
              if (res.data.p.ThisPage <= res.data.p.TotalPage - 3) {
                _pagination += '<li><a onclick="#">...</a></li>';
              }
              _pagination +=
                '<li><a onclick="his_withdrawal(' +
                res.data.p.TotalPage +
                ')">' +
                res.data.p.TotalPage +
                "</a></li>";
            }
          }

          _pagination +=
            '<li><a onclick="his_withdrawal(' +
            res.data.p.TotalPage +
            ')">»</a></li>';
          $(".pagination").empty().html(_pagination);
          $(".recordTable tbody").empty().html(content);
        } else {
          console.log("no data");
        }

        $(".rnote").on("click", function () {
          var rnote = $(this).data("note");
          swal("備註", html_encode(rnote));
        });
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "/logout";
              });
            }
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
        console.log("no data");
      }
    });
}

//回饋紀錄
function his_rebate(page) {
  $("#loader-bg").fadeIn();

  var _page = page ? page : 1;
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data: {
      a: "getRecord",
      t: "rebate",
      p: _page,
      sd: startData,
      ed: endData,
      RebateType: $(".rebate.select").data("rebate")
    },
    dataType: "json",
  })
    .fail(function (res) {
      console.log("fail");
      $("#loader-bg").fadeOut();
      swal("資料查詢失敗", "", "error");
    })
    .done(function (res) {
      $("#loader-bg").fadeOut();

      if (res.success == 0) {
        var content = "";

        for (i = 0; i < res.data.r.length; i++) {
          content +=
            "<tr>" +
            "<td>" +
            (i + 1) +
            "</td>" +
            "<td>" +
            res.data.r[i].TicketID +
            "</td>" +
            "<td>&nbsp;</td>" +
            "<td>回饋</td>" +
            '<td class="text-right" style="padding-right: 25px;">' +
            res.data.r[i].Rebate +
            "</td>" +
            '<td><a class="rdetbtn" data-rdet="' +
            i +
            '" style="cursor:pointer;">詳情</a></td>' +
            "</tr>";

          for (var jj = 0; jj < res.data.r[i].rdet.length; jj++) {
            content +=
              '<tr class="rdet rdet_' +
              i +
              '" style="display:none;background-color:#eef;">' +
              "<td>&nbsp;</td>" +
              "<td>" +
              res.data.r[i].rdet[jj].UpdateDate +
              "</td>" +
              "<td>" +
              res.data.r[i].rdet[jj].TicketID +
              "</td>" +
              "<td>" +
              res.data.r[i].rdet[jj].HallName +
              "&nbsp;" +
              res.data.r[i].rdet[jj].TypeName +
              "</td>" +
              '<td class="text-right" style="padding-right: 25px;">' +
              res.data.r[i].rdet[jj].Rebate +
              "</td>" +
              "<td>&nbsp;</td>" +
              "</tr>";
          }
        }

        if (res.data.p.TotalCount !== 0) {
          $(".noRecord").hide();
          var _pagination = '<li><a onclick="his_rebate(1)">«</a></li>';

          if (res.data.p.TotalPage < 6) {
            for (var i = 1; i <= res.data.p.TotalPage; i++) {
              if (i == res.data.p.ThisPage) {
                _pagination +=
                  '<li><a class="active" onclick="his_rebate(' +
                  i +
                  ')">' +
                  i +
                  "</a></li>";
              } else {
                _pagination +=
                  '<li><a onclick="his_rebate(' + i + ')">' + i + "</a></li>";
              }
            }
          } else {
            if (res.data.p.ThisPage < 3) {
              for (var i = 1; i <= 3; i++) {
                if (i == res.data.p.ThisPage) {
                  _pagination +=
                    '<li><a class="active" onclick="his_rebate(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                } else {
                  _pagination +=
                    '<li><a onclick="his_rebate(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                }
              }
              _pagination += '<li><a onclick="#">...</a></li>';
              _pagination +=
                '<li><a onclick="his_rebate(' +
                (res.data.p.TotalPage - 1) +
                ')">' +
                (res.data.p.TotalPage - 1) +
                "</a></li>";
              _pagination +=
                '<li><a onclick="his_rebate(' +
                res.data.p.TotalPage +
                ')">' +
                res.data.p.TotalPage +
                "</a></li>";
            } else if (res.data.p.ThisPage > res.data.p.TotalPage - 2) {
              _pagination += '<li><a onclick="his_rebate(1)">1</a></li>';
              _pagination += '<li><a onclick="his_rebate(2)">2</a></li>';
              _pagination += '<li><a onclick="#">...</a></li>';
              for (
                var i = res.data.p.TotalPage - 2;
                i <= res.data.p.TotalPage;
                i++
              ) {
                if (i == res.data.p.ThisPage) {
                  _pagination +=
                    '<li><a class="active" onclick="his_rebate(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                } else {
                  _pagination +=
                    '<li><a onclick="his_rebate(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                }
              }
            } else {
              _pagination += '<li><a onclick="his_rebate(1)">1</a></li>';
              if (res.data.p.ThisPage > 3) {
                _pagination += '<li><a onclick="#">...</a></li>';
              }
              for (
                var i = res.data.p.ThisPage - 1;
                i <= res.data.p.ThisPage + 1;
                i++
              ) {
                if (i == res.data.p.ThisPage) {
                  _pagination +=
                    '<li><a class="active" onclick="his_rebate(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                } else {
                  _pagination +=
                    '<li><a onclick="his_rebate(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                }
              }
              if (res.data.p.ThisPage <= res.data.p.TotalPage - 3) {
                _pagination += '<li><a onclick="#">...</a></li>';
              }
              _pagination +=
                '<li><a onclick="his_rebate(' +
                res.data.p.TotalPage +
                ')">' +
                res.data.p.TotalPage +
                "</a></li>";
            }
          }

          _pagination +=
            '<li><a onclick="his_rebate(' +
            res.data.p.TotalPage +
            ')">»</a></li>';
          $(".pagination").empty().html(_pagination);
          $(".recordTable tbody").empty().html(content);
        } else {
          console.log("no data");
        }

        //回饋詳情按鈕
        $(".rdetbtn").on("click", function (e) {
          e.preventDefault();
          var rlogid = $(this).data("rdet");
          $(".rdet_" + rlogid).toggle();
        });
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "/logout";
              });
            }
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
        console.log("no data");
      }
    });
}

//優惠紀錄
function hist_bonus(page) {
  $("#loader-bg").fadeIn();

  var _page = page ? page : 1;
  $.ajax({
    url: "../../member_act.php",
    type: "POST",
    data:
      "a=getRecord&t=bonus" +
      "&p=" +
      _page +
      "&sd=" +
      startData +
      "&ed=" +
      endData,
    dataType: "json",
  })
    .fail(function (res) {
      console.log("fail");
      $("#loader-bg").fadeOut();
      swal("資料查詢失敗", "", "error");
    })
    .done(function (res) {
      $("#loader-bg").fadeOut();

      if (res.success == 0) {
        var content = "";

        for (i = 0; i < res.data.r.length; i++) {
          content +=
            "<tr>" +
            "<td>" +
            (i + 1) +
            "</td>" +
            "<td>" +
            res.data.r[i].GCDate +
            "</td>" +
            "<td>" +
            res.data.r[i].BTicketID +
            "</td>" +
            "<td>優惠</td>" +
            "<td class='text-right' style='padding-right: 25px;'>" +
            res.data.r[i].BonusAmount +
            "</td>" +
            `<td>${res.data.r[i].TicketStatus}</td>`+
            '<td><span class="btn btn-sm btn-info" style="cursor: help;"><span class="rnote" data-note="' +
            html_encode(res.data.r[i].BonusName) +
            '">詳情</span></span></td>' +
            "</tr>";
        }

        if (res.data.p.TotalCount !== 0) {
          $(".noRecord").hide();
          var _pagination = '<li><a onclick="hist_bonus(1)">«</a></li>';

          if (res.data.p.TotalPage < 6) {
            for (var i = 1; i <= res.data.p.TotalPage; i++) {
              if (i == res.data.p.ThisPage) {
                _pagination +=
                  '<li><a class="active" onclick="hist_bonus(' +
                  i +
                  ')">' +
                  i +
                  "</a></li>";
              } else {
                _pagination +=
                  '<li><a onclick="hist_bonus(' + i + ')">' + i + "</a></li>";
              }
            }
          } else {
            if (res.data.p.ThisPage < 3) {
              for (var i = 1; i <= 3; i++) {
                if (i == res.data.p.ThisPage) {
                  _pagination +=
                    '<li><a class="active" onclick="hist_bonus(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                } else {
                  _pagination +=
                    '<li><a onclick="hist_bonus(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                }
              }
              _pagination += '<li><a onclick="#">...</a></li>';
              _pagination +=
                '<li><a onclick="hist_bonus(' +
                (res.data.p.TotalPage - 1) +
                ')">' +
                (res.data.p.TotalPage - 1) +
                "</a></li>";
              _pagination +=
                '<li><a onclick="hist_bonus(' +
                res.data.p.TotalPage +
                ')">' +
                res.data.p.TotalPage +
                "</a></li>";
            } else if (res.data.p.ThisPage > res.data.p.TotalPage - 2) {
              _pagination += '<li><a onclick="hist_bonus(1)">1</a></li>';
              _pagination += '<li><a onclick="hist_bonus(2)">2</a></li>';
              _pagination += '<li><a onclick="#">...</a></li>';
              for (
                var i = res.data.p.TotalPage - 2;
                i <= res.data.p.TotalPage;
                i++
              ) {
                if (i == res.data.p.ThisPage) {
                  _pagination +=
                    '<li><a class="active" onclick="hist_bonus(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                } else {
                  _pagination +=
                    '<li><a onclick="hist_bonus(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                }
              }
            } else {
              _pagination += '<li><a onclick="hist_bonus(1)">1</a></li>';
              if (res.data.p.ThisPage > 3) {
                _pagination += '<li><a onclick="#">...</a></li>';
              }
              for (
                var i = res.data.p.ThisPage - 1;
                i <= res.data.p.ThisPage + 1;
                i++
              ) {
                if (i == res.data.p.ThisPage) {
                  _pagination +=
                    '<li><a class="active" onclick="hist_bonus(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                } else {
                  _pagination +=
                    '<li><a onclick="hist_bonus(' +
                    i +
                    ')">' +
                    i +
                    "</a></li>";
                }
              }
              if (res.data.p.ThisPage <= res.data.p.TotalPage - 3) {
                _pagination += '<li><a onclick="#">...</a></li>';
              }
              _pagination +=
                '<li><a onclick="hist_bonus(' +
                res.data.p.TotalPage +
                ')">' +
                res.data.p.TotalPage +
                "</a></li>";
            }
          }

          _pagination +=
            '<li><a onclick="hist_bonus(' +
            res.data.p.TotalPage +
            ')">»</a></li>';
          $(".pagination").empty().html(_pagination);
          $(".recordTable tbody").empty().html(content);
        } else {
          console.log("no data");
        }
        $(".rnote").on("click", function () {
          var rnote = $(this).data("note");
          swal("備註", html_encode(rnote));
        });
      } else {
        switch (res.success) {
          case -99999:
          case -9999:
            if (logintype) {
              logintype = false;
              swal(res.msg, "", "error").then(function () {
                location.href = "/logout";
              });
            }
            break;
          default:
            swal(res.msg, "", "error");
            break;
        }
        console.log("no data");
      }
    });
}
